import commonService from './commonService'

const getAllByMandate = async (mandateId, signal = null) => {
  return await commonService.getAllBy('mandates', mandateId, 'enrolled_count', signal)
}

export default { getAllByMandate }
